module.exports = __webpack_public_path__ + "static/media/plus.78a0b8a1.svg";